import { render, staticRenderFns } from "./InternalPageHeader.vue?vue&type=template&id=4b5d621f"
import script from "./InternalPageHeader.vue?vue&type=script&lang=js"
export * from "./InternalPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports